import { render, staticRenderFns } from "./startProcess.vue?vue&type=template&id=05ede70e&"
import script from "./startProcess.vue?vue&type=script&lang=js&"
export * from "./startProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports